import React from "react";
import NotFoundPage from "../../ui/modules/service/NotFoundPage";

const BlockedRouteRedirect: React.FC = () => <NotFoundPage />;

export default BlockedRouteRedirect;
